export const NOTIFICATION_ADD = "NOTIFICATION_ADD";
